import 'core-js/stable';

import { loadClientTranslations } from '~l10n/client/translate';

/*----------------------------------------------------------------------------*/
/*    These statments ensure that webpack bundles the generic code we have    */
/*    written that is common between login.js, student.js, and teacher.js.    */
import Dots from 'Dots';

import { setupSocrativeInterceptors } from '../src/api/localAxios';

require('../../shared/less/main-login.less');
require('extensions');

let request = require('../../../shared/Request');
let Messaging = require('Messaging');
let utils = require('Utils');
let platform = require('Platform');
let user = require('user');
let room = require('room');
let Input = require('Input');
let CloseX = require('CloseX');
let popup = require('../../shared/components/popup/PopupController');
let Select = require('Select');
let DownChevronSmall = require('DownChevronSmall');
let InfoIcon = require('InfoIcon');

/*----------------------------------------------------------------------------*/

let Backbone = require('backbone');
setupSocrativeInterceptors();
loadClientTranslations().then(() => {
  require.ensure(['TeacherLoginRouter'], function (require) {
    SOCRATIVE.checkTime.reset();
    SOCRATIVE.initTemplateLoader.stop(); // Hide the loading message (if it's visible)
    require('TeacherLoginRouter');
    Backbone.history.start();
  });
});
